import { RouteObject } from "react-router-dom";
import { AuthGoogle } from "../qg_front/authGoogle";
import { Home } from "../qg_front/home";
import { Dashboard } from "../qg_front/dashboard";
import { QrCode } from "../qg_front/qrCode/qrCode";
import { Statements } from "../qg_front/statements";
import { TermsAndPolicy } from "../qg_front/termsAndPolicy/termsAndPolicy";
import { SupportingDocuments } from "../qg_front/supportingDocuments/supportingDocuments";
import { Billings } from "../qg_front/billings";
import { CompaniesData } from "../qg_front/companiesData";
import { CompaniesDrivers } from "../qg_front/companiesDrivers";
import { TankCapacities } from "../qg_front/tankCapacities";
import { Electric } from "../qg_front/electric";
import { MerchantFix } from "../qg_front/merchantFix";
import { Telemetry } from "../qg_front/telemetry";
import { Cards } from "../qg_front/cards";
import { MandatesAndSepaDirectDebits } from "../qg_front/mandatesAndSepaDirectDebits";
import { Vehicles } from "../qg_front/vehicles";
import { Badges } from "../qg_front/asf";
import { DebugAccount } from "../qg_front/debugAccount";

export const routes: RouteObject[] = [
  {
    path: "/login",
    element: <AuthGoogle />,
  },
  {
    path: "home",
    element: <Home />,
    children: [
      { path: "", element: <Dashboard /> },
      { path: "supporting_documents/:id?", element: <SupportingDocuments /> },
      { path: "merchant_fix/:tab?", element: <MerchantFix /> },
      { path: "drivers/:tab?", element: <CompaniesDrivers /> },
      { path: "vehicles/:tab?", element: <Vehicles /> },
      { path: "tank_capacities", element: <TankCapacities /> },
      { path: "cards/:tab?/:id?", element: <Cards /> },
      { path: "badges/:tab?/:id?", element: <Badges /> },
      { path: "electric/:tab?", element: <Electric /> },
      { path: "companies_data/:tab?/:id?", element: <CompaniesData /> },
      {
        path: "mandates_and_sepa_direct_debits/:tab?/:id?",
        element: <MandatesAndSepaDirectDebits />,
      },
      { path: "qrCode", element: <QrCode /> },
      { path: "statements/:tab?/:id?", element: <Statements /> },
      { path: "termsAndPolicy", element: <TermsAndPolicy /> },
      { path: "billings/:tab?/:id?", element: <Billings /> },
      { path: "telemetry/:tab?/:id?", element: <Telemetry /> },
      { path: "debug_account", element: <DebugAccount /> },
    ],
  },
  {
    path: "*",
    element: <AuthGoogle />,
  },
];
